import { Order as OrderType, Items, Modifier } from 'data/types/order';
import formatPhoneNumber from 'utils/formatPhoneNumber';
import formatPriceNumber from 'utils/formatPrice';
import { normalizeOrderType, normalizeOrderStatus } from 'model/global';
import formatName from 'utils/formatName';

export const normalizeModifiers = (data: Modifier) => ({
  name: data.name,
  price: formatPriceNumber(data.price),
  modifierGroup: data.modifierGroup,
  quantity: data.quantity,
  note: data.note,
});

export const normalizeItems = (data: Items) => ({
  category: data.category,
  name: data.name,
  quantity: data.quantity,
  price: formatPriceNumber(data.price),
  note: data.note,
  label: data.label,
  modifiers: data.modifiers?.map(normalizeModifiers),
});

export const normalizeOrder = (data: OrderType) => ({
  id: data.id,
  status: normalizeOrderStatus(data.status),
  integrationOrderFullId: data.integrationOrderFullId,
  integrationOrderId: data.integrationOrderId,
  type: normalizeOrderType(data.type),
  integration: {
    id: data.integration.id,
    name: data.integration.name,
    logo: data.integration.logo,
    orderId: data.integration.orderId,
  },
  brand: {
    id: data.brand.id,
    name: data.brand.name,
    logo: data.brand.logo,
  },
  times: {
    delivery: data.times.delivery,
    ordered: data.times.ordered,
    pickup: data.times.pickup,
    updated: data.times.updated,
  },
  customer: {
    name: {
      firstName: data.customer.name.firstName,
      lastName: data.customer.name.lastName,
      displayName: formatName(data.customer.name.displayName),
    },
    address: {
      addressLine1: data.customer.address.addressLine1,
      addressLine2: data.customer.address.addressLine2,
      city: data.customer.address.city,
      state: data.customer.address.state,
      zipCode: data.customer.address.zipCode,
    },
    phone: formatPhoneNumber(data.customer.phone),
    phoneCode: data.customer.phoneCode,
    email: data.customer.email,
  },
  courier: {
    name: {
      firstName: data.courier.name.firstName,
      lastName: data.courier.name.lastName,
      displayName: data.courier.name.displayName,
    },
    phone: data.courier.phone
      ? formatPhoneNumber(data.courier.phone)
      : undefined,
  },
  itemCount: data.itemCount,
  createdAt: data.createdAt,
  items: data.items.map(normalizeItems),
  payment: {
    subtotal: formatPriceNumber(data.payment.subtotal),
    tax: formatPriceNumber(data.payment.tax),
    discount: formatPriceNumber(data.payment.discount),
    total: formatPriceNumber(data.payment.total),
  },
  notes: { order: data.notes.order, delivery: data.notes.delivery },
});

export type Order = ReturnType<typeof normalizeOrder>;
